import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { CookieService } from 'ngx-cookie-service';

import { Campus }     from 'src/app/core/models/api/campus.model';
import { Subscriber } from 'src/app/core/models/api/subscriber.model';

import { CampusService } from 'src/app/core/services/api/campus.service';
import { SubscriberService } from 'src/app/core/services/api/subscriber.service';
import { ModalService } from 'src/app/shared/services/modal.service';

@Component({
    selector: 'app-newsletter',
    templateUrl: './newsletter.component.html',
    styleUrls: ['./newsletter.component.scss']
})
export class NewsletterComponent implements OnInit {

    campus: Campus;

    mailFormControl: FormControl = new FormControl('', [Validators.required, Validators.email]);
    
    title        : string;
    content      : string;
    authorization: string;
    lopd         : string;
    lopdChecked  : boolean = false;

    constructor(
        private matDialog: MatDialog, 
        private cookieService: CookieService, 
        private campusService: CampusService, 
        private subscriberService: SubscriberService,
        private modalService: ModalService) { }

    ngOnInit() { 

        this.campus = this.campusService.campusActive;
        this.getCampusResources();

    }

    getCampusResources() {

        var titleResource         = this.campus.resources.find(x => x.resourceId == 'newsletter-title');
        var contentResource       = this.campus.resources.find(x => x.resourceId == 'newsletter-text');
        var authorizationResource = this.campus.resources.find(x => x.resourceId == 'newsletter-authorization');
        var lopdResource          = this.campus.resources.find(x => x.resourceId == 'newsletter-lopd');
        
        this.title         = titleResource         ? titleResource.value         : null;
        this.content       = contentResource       ? contentResource.value       : null;
        this.authorization = authorizationResource ? authorizationResource.value : null;
        this.lopd          = lopdResource          ? lopdResource.value          : null;

    }

    subscribeToNewsletter() {

        var subscriber = new Subscriber();
            subscriber.campusId = this.campus.campusId;
            subscriber.mail     = this.mailFormControl.value;

        this.subscriberService.subscribeByPopup(subscriber).subscribe(
            () => { 
                this.cookieService.set('newsletter', 'false', { expires: 90 });
                this.matDialog.closeAll();
                this.modalService.showConfirmationModal(
                    "Su suscripción a nuestra newsletter se ha efectuado correctamente.<br/>", 
                    "¡Muchas gracias!"
                ); 
            }
        );
    }

    closeDialog() {

        this.cookieService.set('newsletter', 'false', { expires: 7 });
        this.matDialog.closeAll();

    }

}
